// export const API_ENDPOINT = 'https://359d-122-160-255-233.ngrok-free.app/api/'
export const API_ENDPOINT = 'https://api.getrentid.io/api'
// export const API_ENDPOINT = 'http://localhost:3001/'
